UploadTeachers = new (function () {
  let wrapper;

  this.initForm = () => {
    wrapper = $(".upload_teacher_wrapper");
    if (!wrapper || !wrapper.length) return;
    Shared.applyFileValidation({
      fileSelector: "#uploads_teacher_file",
      submitSelector: ".upload_teacher_wrapper button[type='submit']",
    });
  };
})();
